import { Tabs } from "antd";
import PrivacyPolicyTabIcon from "../../../assets/web/icons/PrivacyPolicyTabIcon";
import Container from "../../../components/web/Container";
import PublicLayout from "../../../layouts/PublicLayout";

export default function PrivacyPolicy() {
  return (
    <PublicLayout title="Privacy Policy | Sheba Business Portal">
      <Container>
        <div className="py-20">
          <Tabs defaultActiveKey="1" items={items} tabPosition="left" />
        </div>
      </Container>
    </PublicLayout>
  );
}

const DigiGoPrivacyPolicyContent = () => {
  return (
    <div>
      <div className="text-[#001652] text-[36px] font-bold mb-9">
        digiGO - Privacy Policy
      </div>
      <div className="text-[#2D3643] font-semibold text-[22px]">
        Introduction
      </div>
      <div className="my-2">
        “digiGO” an online Human Resource Management (HRM) platform, owned and
        operated by Sheba Platform Limited, which may be access through the
        Website and Mobile App (hereinafter “digiGO” or “the Platform”)
        recognizes the importance of privacy of its Users and also of
        maintaining confidentiality of the information provided by its Users as
        a responsible data controller and data processer. 
      </div>
      <div className="my-2">
        This Privacy Policy provides for the practices for handling and securing
        User's Personal Information (defined hereunder) and any other individual
        whose details are provided to digiGO and its subsidiaries and
        affiliates.
      </div>
      <div className="my-2">
        This Privacy Policy is applicable to any person (‘User’) who subscribes,
        uses or utilizes, or inquires about any product(s) or service(s) made
        available by digiGO through any of its customer interface channels
        including its website, mobile site, mobile app & offline channels
        including call centers and offices (collectively referred herein as
        "Sales Channels"). User(s) may access various Human Resource Management
        features in the Platform including employee directory, HR announcements,
        employee Profile, tracking attendance, leaves, checkout, expense claim,
        attendance report, leave application, payroll settings etc.
        (“Service(s)”).
      </div>
      <div className="my-2">
        For the purpose of this Privacy Policy, wherever the context so requires
        "you" or "your" shall mean User and the term "we", "us", "our" shall
        mean digiGO. For the purpose of this Privacy Policy, Website means the
        website(s), mobile site(s) and mobile app(s).
      </div>
      <div className="my-2">
        By using or accessing the Website or other Sales Channels, the User
        hereby agrees with the terms of this Privacy Policy and the contents
        herein and this consent from you shall be deemed as valid permission as
        required under section 26 of Digital Security Act, 2018 in relation to
        possession, retention and usage of your Personal Information. If you
        disagree with this Privacy Policy please do not use or access our
        Website or other Sales Channels.
      </div>
      <div className="my-2">
        This Privacy Policy does not apply to any website(s), mobile sites and
        mobile apps of third parties, even if their websites/products are linked
        to our Website. User should take note that information and privacy
        practices of our business partners, advertisers, sponsors or other sites
        to which we provide hyperlink(s), may be materially different from this
        Privacy Policy. Accordingly, it is recommended that you review the
        privacy statements and policies of any such third parties with whom they
        interact.
      </div>
      <div className="my-2 font-semibold text-[22px]">
        Users outside the geographical limits of Bangladesh
      </div>
      <div className="my-2">
        Please note that the data shared with us shall be primarily processed in
        Bangladesh and such other jurisdictions where a third party engaged by
        digiGO may process the data on its behalf. By agreeing to this policy,
        you are providing digiGO with your explicit consent to process your
        personal information for the purpose(s) defined in this policy. This
        consent shall be deemed to be a sufficient consent to satisfy the
        requirement of section 26 of Digital Securities Act, 2018. The data
        protection laws in Bangladesh or such other jurisdictions mentioned
        above may differ from those of your country of residence.
      </div>
      <div className="my-2">
        If you have any concerns in the processing your data and wish to
        withdraw your consent, you may do so by writing to the following email
        id: sbusiness@sheba.xyz. However, if such processing of data is
        essential for us to be able to provide service to you, then we may not
        be able to serve or confirm your subscription after your withdrawal of
        consent. For instance, if you want to obtain any feature of employee
        attendance, leave approval, then certain personal information of yours
        and the employee(s) like contact details, gender, email address, leave
        purpose, personal information etc. may have to be shared to us, and the
        same may be further processed by us.{" "}
      </div>
      <div className="my-2">
        A withdrawal of consent by you for us to process your information may:
        <ul className="list-disc list-inside">
          <li>
            severely inhibit our ability to serve you properly and in such case,
            we may have to refuse the subscription altogether, or
          </li>
          <li>
            unreasonably restrict us to service your subscription which may
            further affect the features of the Platform.
          </li>
        </ul>
      </div>
      <div className="my-2">
        The Users may submit inquiries regarding Personal Data protection,
        privacy and security matters to the above-mentioned email address.{" "}
      </div>
      <div className="my-2 font-semibold text-[22px]">
        Type of information (we collect)
      </div>
      <div className="my-2">
        The information as detailed below is collected for us to be able to
        provide the services chosen by you and also to fulfill our legal
        obligations as well as our obligations towards third parties.
      </div>
      <div className="my-2">
        <ul className="list-decimal list-inside">
          <li>
            Personal Information: User shall include the information shared by
            the User and collected by us for the following purposes:Registration
            on the Platform: Information which you provide while subscribing to
            or registering or using the Platform, including but not limited to
            information about your and any other individuals’ personal identity
            such as name, gender, marital status, religion, age etc., User(s)
            contact details such as your email address, postal addresses,
            nationality, job title, date you first started working for your
            employer, department you work in, employee ID/ national security
            number, address, country, city, postcode, family status, spouse’s
            and other dependents name, telephone (mobile or otherwise) and/or
            fax numbers. The information may also include information such as
            your banking details (including bank name, account number, branch
            address, credit/debit card) and any other information relating to
            your income; details regarding your salary and work (pay period,
            payment frequency, base salary, gross salary, overtime, bonuses,
            commissions, statutory payments such as sick, maternity/paternity
            leave, salary payment currency, credential regarding the right to
            work in your jurisdiction, tax code, emergency contact details
            (name, relation, phone number(s), email address(es), city, country,
            post code), termination date, termination reason, probation end
            date, status in the system and in the workplace, IP address and
            other unique identifiers, User’s information relating to tax
            declarations, information the Customer chooses to collect and other
            information User may choose to provide to digiGO payment history
            etc. (as shared by you).
          </li>
          <li>
            Other information: We many also collect some other information and
            documents including but not limited to:  Your usernames, passwords,
            email addresses and other security-related information used by you
            in relation to our Services. Data either created by you or by a
            third party and which you wish to store on our servers such as image
            files, documents etc. Personal contact information (including your
            and your organization’s users’ name, home address, personal
            telephone number(s) and/or personal email address). Usage and
            technical data, which includes information about how you use our
            website, products and services, and traffic data, weblogs, pages you
            access and other communication data (i.e. information obtained via
            cookies). Device logs of the users for the purposes of calculating
            attendance and payroll using the rules configured by the User. The
            information collected consists of employee or attendance id along
            with timestamps of punches (in and out entries). Data available in
            public domain or received from any third party including social
            media channels, including but not limited to personal or
            non-personal information from your linked social media channels
            (like name, email address, friend list, profile pictures or any
            other information that is permitted to be received as per your
            account settings) as a part of your account information. Information
            pertaining any other individual or employee(s) whose details you
            provide to us in relation to our Services. In such case, you must
            confirm and represent that each of the other individual or
            employee(s) whose details you provide to us in relation to our
            Services, has agreed to have the information shared by you disclosed
            to us, explain to them how we collect, use, disclose and retain
            their personal information and/or directing them to read out Privacy
            Policy; and ensure that you comply with the application Data
            Protection Laws in relation to such disclosure Information when the
            User fill out a form or information, place an order using the
            Platform, complete online forms, take part in surveys or participate
            in other interactive area that may appear on the Platform, interact
            using message or chatbots.
          </li>
        </ul>
      </div>
      <div className="my-2 font-semibold text-[22px]">Location Policy</div>
      <div className="my-2">
        This Privacy Policy section specifically addresses the location tracking
        integrated in "Attendance" feature within digiGO. Live Tracking is
        designed to enhance attendance management and productivity monitoring.
        We value the privacy of our customers and are committed to transparent
        data practices.
      </div>
      <div className="my-2">
        <ul className="list-decimal list-inside">
          <li>
            Live Tracking Usage: The location tracking in 'Attendance' feature
            in digiGO is designed to automate attendance management and enhance
            productivity monitoring. It enables real-time tracking of employees'
            locations during office hours. This feature is integral to improving
            HR functions.{" "}
          </li>
          <li>
            Permissions and Transparency: To ensure transparency and respect
            individual privacy, digiGO requires in-app acknowledgments from
            employees to access their location. Without their explicit
            permissions, digiGO cannot access their location data. Employees
            receive notifications stating, "Your location is being tracked" to
            maintain transparency. 
          </li>
          <li>
            Benefits & Usage: Location tracking offers several benefits
            including ​ Productivity Monitoring: It provides insights into
            employee work hours, helping companies identify inefficiencies and
            areas for improvement. Transparency: Tracking locations fosters
            better transparency between managers and team members, promoting
            collaboration and improved project outcomes. Remote Work Management:
            For remote or distributed teams, digiGO helps managers monitor work
            hours, tasks, and progress, ensuring remote employees contribute
            effectively. Time and Attendance: Integrated into digiGO, this
            feature monitors work hours, breaks, and attendance, simplifying HR
            tasks. Health and Safety: In safety-critical industries, Live
            Tracking ensures employees adhere to safety protocols and
            guidelines. Data Security: We prioritize data security and employ
            robust measures to protect our customers' information. Live Tracking
            data is securely stored and accessible only to authorized personnel.
            User Control: Users have control over Live Tracking permissions. You
            can manage your preferences regarding location tracking within the
            app. Location Policy Upgradation: We may update our location privacy
            policy to reflect changes in features, legal requirements, or
            customer feedback. We will notify users of any significant updates.
          </li>
        </ul>
      </div>
      <div className="my-2 font-semibold text-[22px]">
        How we use your personal information
      </div>
      <div className="my-2">
        The Personal Information collected maybe used in the following manner:
      </div>
      <div className="my-2">
        In providing our Service(s), we may use Personal Information including,
        payment details which include cardholder name, credit/debit card number
        (in encrypted form) with expiration date, banking details, wallet
        details etc. as shared and allowed to be stored by you. We may also use
        the information of employee list as available in or linked with your
        account. Our Terms of Use governs the delivery, access, and use of the
        Services and Mobile Apps, including the processing of Personal
        Information and data submitted through Services accounts.{" "}
      </div>
      <div className="my-2">
        <div className="font-semibold">
          We may also use your Personal Information for several reasons
          including but not limited to:
        </div>
        <ul className="list-disc list-inside">
          <li>
            To provide you and your organization’s users with the Service(s)
          </li>
          <li>To allow you to upload, store and access client data</li>
          <li>
            To provide you and your organization’s users with user support
          </li>
          <li>
            To ensure security for you, your organization’s users, our staff and
            other users of the service
          </li>
          <li>To allow our customer service to contact you, if necessary</li>
          <li>
            To customize the content of our website, mobile site and mobile app
          </li>
          <li>
            To request for reviews of products or services or any other
            improvements
          </li>
          <li>To send verification message(s) or email(s)</li>
          <li>
            To validate/authenticate your account and to prevent any misuse or
            abuse.
          </li>
          <li>To contact you to offer a special gift or offer.</li>
        </ul>
      </div>
      <div className="my-2">
        <div className="font-semibold">Surveys</div>
        We value opinions and comments from our Users and frequently conduct
        surveys, both online and offline. Participation in these surveys is
        entirely optional. Typically, the information received is aggregated,
        and used to make improvements to Website, other Sales Channels, services
        and to develop appealing content, features and promotions for members
        based on the results of the surveys. Identity of the survey participants
        is anonymous unless otherwise stated in the survey.
      </div>
      <div className="my-2">
        <div className="font-semibold">
          Marketing Promotions, Research and Programs
        </div>
        Marketing promotions, research and programs help us to identify your
        preferences, develop programs and improve user experience. digiGO may
        sponsor promotions to give its Users the opportunity to subscription
        offers. Personal Information collected by us for such activities may
        include contact information and survey questions. We may use such
        Personal Information to notify contest winners and survey information to
        develop promotions and product improvements. As a registered User, you
        will also occasionally receive updates from us about fare sales in your
        area, special offers, new digiGO services, other noteworthy items and
        marketing programs.
      </div>
      <div className="my-2">
        In addition, you may be sent periodic marketing emails, newsletters and
        exclusive promotions offering special deals. From time to time we may
        add or enhance services available on the Mobile App. To the extent these
        services are provided, and used by you, we will use the Personal
        Information you provide to facilitate the service(s) requested. For
        example, if you email us with a question, we will use your email
        address, name, nature of the question, etc. to respond to your question.
        We may also store such Personal Information to assist us in making the
        Platform the better and easier to use for our Users.
      </div>
      <div className="my-2">
        We may share your information with third parties who provide services to
        Us. These third parties are authorized to use your Personal Information
        only as necessary to provide these services to Us. These services may
        include the provision of (i) email services to send marketing
        communications, (ii) mapping services, (iii) customer service or
        support, and (iv) providing cloud computing infrastructure.
      </div>
      <div className="my-2">
        We employ and contract with people and other entities that perform
        certain tasks on Our behalf and who are under Our control such as an
        email service provider to send emails on Our behalf, mapping service
        providers, and customer support providers Our “Sub-Processors”). We may
        need to share Personal Information with Our Sub-Processors in order to
        provide Services to you. Unless We tell you differently, Our
        Sub-Processors do not have any right to use Personal Information or
        other information We share with them beyond what is necessary to assist
        Us.
      </div>
      <div className="my-2">
        In certain cases, we collect and use your personal information to comply
        with laws. For instance, we collect from companies regarding information
        pertaining to place of establishment and bank account information for
        identity verification and other purposes including but not limited to
        information required for necessary to access and clear payment gateways.
      </div>
      <div className="my-2 font-semibold text-[22px]">
        How long do we keep your personal information?
      </div>
      <div className="my-2">
        digiGO will retain your Personal Information on its servers for as long
        as is reasonably necessary for the purposes of providing the Services.
        It also allows facilitating your Facebook and Google+ login.
      </div>
      <div className="my-2">
        <div className="font-semibold">Specific permissions</div>
        You may choose to specifically give permission to digiGO to access the
        following in your phone. Note that, while the permissions below are not
        necessary, without the said permissions, the Platform will not be fully
        functional and the services provided by the App/Website will not serve
        its intended purpose. The use of each of the permissions are detailed
        below:
      </div>
      <div className="my-2">
        <div className="font-semibold">Android Permissions</div>
        Location: This permission enables us to give you the benefit of location
        specific deals and provide you a personalized experience. When you
        launch digiGO app/ use the sBusiness Website to make an input, we may
        auto-detect your location. It will help companies to enhance their HR
        efficiency with digiGO's location tracking. This will boost
        productivity, transparency, remote work management, and safety
        compliance. SMS: If you allow us to access your SMS, we read your SMS to
        autofill or prepopulate ‘OTP’ while making a transaction and to validate
        your mobile number. This provides you a seamless purchase experience
        while making a booking and you don’t need to move out of the app to read
        the SMS and then enter it in the app. Phone: The app requires access to
        make phone calls so that you can make phone calls to Users, and our
        customers contact centers directly through the app. Photo/ Media/ Files:
        The libraries in the app use these permissions to allow map data to be
        saved to your phone's external storage, like SD cards. By saving map
        data locally, your phone doesn't need to re-download the same map data
        every time you use the app. Also, it allows us to access/capture photo
        from storage/camera and store it locally. 
      </div>
      <div className="my-2">
        <div className="font-semibold">IOS Permissions</div>
        Notifications: If you opt in for notifications, it enables us to send
        across exclusive deals, promotional offers, subscription related
        updates, etc. on your device. If you do not opt for this, updates for
        your travel like PNR status, subscription confirmation, refund (in case
        of cancellation), etc. will be sent through SMS. Location: This
        permission enables us to give you the benefit of location specific deals
        and provide you a personalized experience. The User may enable location
        tracking technology for time keeping purposes. Your options are
        personalized based on your locations. Cookies and IP Addresses: We may
        obtain information about your and your organization’s users’ computer,
        which includes your and your organization’s users’ IP address, browser
        type and operating system where available. This accumulation of data is
        used to assist system administration.
      </div>
      <div className="my-2 font-semibold text-[22px]">
        How we protect your personal information
      </div>
      <div className="my-2">
        All payments on the Website are secured. This means all Personal
        Information you provide is transmitted using TLS (Transport Layer
        Security) encryption. TLS is a proven coding system that lets your
        browser automatically encrypt, or scramble, data before you send it to
        us. Website has stringent security measures in place to protect the
        loss, misuse, and alteration of the information under our control.
        Whenever you change or access your account information, we offer the use
        of a secure server. Once your information is in our possession we adhere
        to strict security guidelines, protecting it against unauthorized
        access. By agreeing to this Privacy Policy, you hereby agree, understand
        and acknowledge that:
      </div>
      <div className="my-2">
        <div className="font-semibold">Android Permissions</div>
        digiGO/Sheba Platform Limited (the owner and operator of the
        App/Website) has adopted all the measures reasonably necessary for
        protection of your Personal Information and any other information
        accessed by it pursuant to the permissions granted above. digiGO/Sheba
        Platform Limited (the owner and operator of the App/Website) shall not
        be responsible for any unauthorized disclosure of information, including
        any disclosure by its employees, if the said disclosure takes place
        beyond knowledge. digiGO/Sheba Platform Limited (the owner and operator
        of the App/Website) will cooperate with you in order to ensure
        compliance with applicable data protection provisions. For example, to
        enable you to effectively guarantee the exercise of data subjects’
        rights (rights of access, rectification, erasure, blocking, opposition)
        to manage incidents including forensic analysis in case of security
        breach.
      </div>
      <div className="my-2 font-semibold text-[22px]">Terms of services</div>
      <div className="my-2">
        Please also visit our Terms of Service/Terms of Use which establishes
        the use, disclaimers, and limitations of liability governing the use of
        our Platform.
      </div>
      <div className="my-2 font-semibold text-[22px]">
        Withdraw of consent and permission
      </div>
      <div className="my-2">
        You may withdraw your consent to submit any or all Personal Information
        or decline to provide any permissions to digiGO on its Website/App as
        covered above at any time. In case, you choose to do so, then your
        access to the Website/App may be limited, or we might not be able to
        provide the services to you. You may withdraw your consent by sending an
        email to ‘sbusiness@sheba.xyz’.
      </div>
      <div className="my-2 font-semibold text-[22px]">
        Your rights in respect of personal information
      </div>
      <div className="my-2">
        You may access your Personal Information from your user account with
        digiGO, may also correct your personal information or delete such
        information (except some mandatory fields) from your user account
        directly.{" "}
      </div>
      <div className="my-2 font-semibold text-[22px]">
        Eligibility to transact with us
      </div>
      <div className="my-2">
        You must at least 18 years of age to transact directly with
        sBusiness.xyz and also to consent to the processing of your personal
        data.
      </div>
      <div className="my-2 font-semibold text-[22px]">
        Changes to the privacy policy
      </div>
      <div className="my-2">
        We reserve the rights to revise the Privacy Policy from time to time to
        suit various legal, business and customer requirement. We will duly
        notify the users as may be necessary.
      </div>
      <div className="my-2">
        You may always submit concerns regarding this Privacy Policy via email
        to us at sbusiness@sheba.xyz. digiGO team shall endeavor to respond to
        all reasonable concerns and enquiries.
      </div>
    </div>
  );
};

const items = [
  {
    label: (
      <div className="flex items-center gap-2 border p-4 rounded min-w-36 mb-3">
        <PrivacyPolicyTabIcon /> <span>digiGo</span>
      </div>
    ),
    key: "1",
    children: <DigiGoPrivacyPolicyContent />,
  },
];
